import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, TipoConvenioEvento,  } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class TipoConvenioEventoService extends BaseResourceService<TipoConvenioEvento> {

  constructor(
    protected injector: Injector
  ) {
    super(`tipos-convenio-evento`, injector);
  }

}
